import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Monitor = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">⚙️ Monitor</h1>
          <p className="text-muted-foreground">uptime, load, errors</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Monitor Dashboard</CardTitle>
            <CardDescription>uptime, load, errors</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Monitor content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Monitor;